
import { Lotto } from "./Lotto";


export const Bonanza5 = ({dataList, summary, loading, error}) => {
    console.log("Rendering Bonanza5")

    return (  
        <Lotto
           gameName="Bonanza 5" 
           dataList={dataList}
           summary={summary}
           loading={loading}
           error={error}
        />
    )
}
